import React from "react"

import { FaPhone, FaInstagram, FaLocationArrow } from "react-icons/fa"
import habitatHillsLogo from "../../images/habitat-hills-logo.png"
import { Link, useStaticQuery, graphql } from "gatsby"

const Footer = () => {
  const footerData = useStaticQuery(graphql`
    {
      contact: wordpressPage(slug: { eq: "contact" }) {
        acf {
          phone
          instagram
          location {
            info
            link_to_google_maps
          }
        }
      }
    }
  `)
  return (
    <React.Fragment>
      <div className="container mt-5">
        <div className="row mx-auto border-top py-5">
          <div className="pl-0 col-10 col-sm-10 col-md-6 col-lg-4">
            <img
              style={{ width: "3rem" }}
              src={habitatHillsLogo}
              alt="Habitat Hills Logo"
            />
            <h6 className="text-muted mt-3">
              <small>Connect with Habitat Hills</small>
            </h6>
            <ul
              style={{ listStyleType: "none" }}
              className="mx-0 px-0 d-flex social-icons"
            >
              <li>
                <a
                  className="text-muted"
                  href={`tel:${footerData.contact.acf.phone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaPhone />
                </a>
              </li>
              <li>
                <a
                  className="text-muted"
                  href={footerData.contact.acf.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
              </li>
              <li>
                <a
                  className="text-muted"
                  href={footerData.contact.acf.location.link_to_google_maps}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLocationArrow />
                </a>
              </li>
            </ul>
            <p className="text-muted">
              <small>{footerData.contact.acf.location.info}</small>
            </p>
          </div>
        </div>
        <div>
          <p className="text-muted">
            <small>
              {new Date().getFullYear().toString()} Habitat Hills Resort
            </small>
          </p>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Footer
